export default {
    startPage: {
        title: 'Vue 学习'
    },
    menu: {
        Documents: 'Sportdokumente',
        Setting: 'Systemeinstellungen',
        Applications: "Testsystem",
        Report: "Analysebericht",
        AthleteDocuments: "Athleten",
        SportProject: "Sportprojekt",
        Options: "Grundeinstellungen",
        Permission: "Rechteverwaltung",
        StandardData: "Standardwerteverwaltung",
        MuscleStrengthStandard: 'Tragbare Muskelkraftreferenzwerte',
        UserManagement: "Personalverwaltung",
        Subject: "Athletendetails",
        Record: "Persönliche Aufzeichnungen",
        Result: "Testergebnisse",
        Actions: "Bewegungsdaten",
        SportsPerformanceStandardData: 'Sportfunktionsleistungssystem',
        MuscleStrengthStandardData: 'Tragbares Muskelkrafttestsystem',
    },
    userMenu: {
        confirmExit: 'Abmelden',
        confirmMsg: 'Bestätigen Sie, dass Sie sich abmelden möchten?',
        DarkMode: 'Dunkler Modus',
        Modify: 'Profil bearbeiten',
        Account: 'Konto',
        UserName: 'Benutzername',
    },
    options: {
        Title: 'Präferenzeinstellungen',
        Language: 'Sprache',
        ModifyNotice: 'Änderung erfolgreich',
        ModifyNotice2: 'Änderung fehlgeschlagen',
        SystemSettings: 'Grundeinstellungen',
        AccountSetting: 'Kontoeinstellungen',
        Account: 'Konto',
        OrganizationInfo: 'Organisationsinformationen',
        CompanyName: 'Firmenname:',
        CompanyCode: 'Firmencode:',
        CustomLogo: 'Benutzerdefiniertes Logo',
        Name: 'Name',
        Preview: 'Vorschau',
        UploadPictures: 'Klicken Sie zum Hochladen von Bildern',
        Notice1: 'Optimale Bildgröße: Höhe 48px, Breite bis 200px, <1Mb, PNG/JPG-Format',
        ModifyPassword: 'Passwort zurücksetzen/ändern',
        confirmExit: 'Abmelden',
        ModifyName: 'Name ändern',
        notice2: 'Name erfolgreich geändert',
        notice3: 'Bitte geben Sie Ihren Namen ein',
        Lable: {
            Multilingual: 'Mehrsprachig',
            Logo: 'Benutzerdefiniertes Logo',
        }
    },
    login: {
        Label: {
            UserName: 'Benutzername',
            Password: 'Passwort',
            Login: 'Anmelden',
            Reset: 'Passwort zurücksetzen',
            Title: 'Bitte anmelden',
            Title2: 'Registrierung',
            Forget: 'Passwort vergessen?',
            Remember: 'Passwort merken',
            Register: 'Zum Registrieren >>',
            ToLogin: 'Konto vorhanden? Zum Anmelden >>',
            Captche: 'Verifizierungscode abrufen',
            Retry: 'Erneut abrufen',
            Agree: 'Nutzungsbedingungen akzeptieren',
            UserNamePlaceholde: 'Bitte geben Sie Ihren Benutzernamen ein',
            PasswordPlaceholde: 'Bitte geben Sie Ihr Passwort ein',
            CompanyCodePlaceholder: 'Bitte geben Sie den Firmencode ein',
            MailBoxPlaceHolder: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
            CaptchaPlaceholder: 'E-Mail-Verifizierungscode',
        },
        Message: {
            PasswordLength: 'Passwortlänge: 8-16 Zeichen',
            CaptchaSuccess: 'Verifizierungscode gesendet',
            Agree: 'Bitte lesen und markieren Sie die Nutzungsbedingungen',
            AccountEmpty: 'Bitte korrekt ausfüllen: E-Mail-Adresse',
            Registered: 'Registrierung erfolgreich',
            loginFaild: 'Anmeldung fehlgeschlagen',
            Captcha: 'Verifizierungscode zu kurz',
            CaptchaLenthL: 'Bitte vollständigen Verifizierungscode eingeben',
            CompanyCodeLength: 'Bitte korrekten Firmencode eingeben',
        }
    },
    forget: {
        Label: {
            Title: 'Passwort zurücksetzen',
            GoToLogin: 'Zum Anmelden >>',
            Captche: 'Verifizierungscode abrufen',
            Reset: 'Passwort zurücksetzen',
            Retry: 'Erneut abrufen',
            Contact: 'Bei Problemen auf dieser Seite kontaktieren Sie bitte den Kundendienst',
            AccountPlaceholder: 'Bitte geben Sie Ihre Anmelde-E-Mail-Adresse ein',
            CaptchaPlaceholder: 'E-Mail-Verifizierungscode',
            PasswordPlaceholder: 'Neues Passwort',
            ModifyPassword: 'Passwort ändern',
        },
        Message: {
            CaptchaSuccess: 'Verifizierungscode gesendet',
            ResetSuccess: 'Passwortrücksetzung erfolgreich',
            AccountEmpty: 'Bitte korrekt ausfüllen: E-Mail-Adresse',
        }
    },
    global: {
        HomePage: 'Startseite',
        Loading: 'Laden',
        CopySuccess: 'Kopieren erfolgreich',
        CopyFailed: 'Kopieren fehlgeschlagen',
        Refresh: 'Aktualisieren',
        Add: 'Hinzufügen',
        Create: 'Erstellen',
        Modify: 'Ändern',
        Confirm: 'Bestätigen',
        Cancel: 'Abbrechen',
        Save: 'Speichern',
        View: "Anzeigen",
        Edit: "Bearbeiten",
        Delete: "Löschen",
        Finish: "Abschließen",
        LastWeek: "Letzte Woche",
        LastMonth: "Letzter Monat",
        Last3Month: "Letzte drei Monate",
        StartDate: "Startdatum",
        EndDate: "Enddatum",
        TestProject: "Testprojekt",
        SportProject: "Sportprojekt",
        None: "Unbegrenzt",
        Gender: "Geschlecht",
        RequestFailed: 'Anforderung fehlgeschlagen!',
        ResponseFailed: 'Antwort fehlgeschlagen!',
        LoadSuccess: 'Download erfolgreich',
        LoadFailed: 'Download fehlgeschlagen',
        EditRelation: 'Sportbeziehung bearbeiten',
        EditSubject: 'Sportlerinformationen bearbeiten',
        EditProject: 'Sportprojekt bearbeiten',
        Import: 'Importieren',
        Export: 'Exportieren',
        NoneData: 'Keine Daten verfügbar',
        NoneRank: 'Keine Rangliste verfügbar',
        SaveSuccess: "Speichern erfolgreich",
        Checked: 'Ausgewählt',
        Close: 'Schließen',
    },
    Permission: {
        Label: {
            Title: "Rechteverwaltung",
            Enable: "Aktivieren",
            Description: "Beschreibung",
            ExpireDate: "Ablaufdatum",
            CreateGroup: "Gruppe erstellen",
            GroupRole: "Rollen-Typ",
            GroupName: "Rollenname",
            SelectRoleType: "Rollentyp auswählen",
        },
        Message: {
            GetGroupsFailed: "Gruppenabruf fehlgeschlagen",
            GetApplicationListFailed: "Anwendungslistenabruf fehlgeschlagen",
            ChangeUnsaved: "Ungespeicherte Änderungen vorhanden. Möchten Sie die Seite verlassen?",
            ComfirmToDelete: "Bestätigen Sie, dass Sie diese Gruppe löschen möchten?",
            DeleteSuccess: "Gruppelöschung erfolgreich",
        }
    },
    Documents: {
        Lable: {
            ViewPersonDocument: "Persönliches Dossier anzeigen",
            InvationInfo: "Einladung zur Registrierung",
            DeleteInvation: "Einladung löschen",
            ViewHistoryRecords: "Historische Aufzeichnungen anzeigen",
            ViewDetailRecords: "Detailaufzeichnungen anzeigen",
            TestDetialExport: "Detailaufzeichnungen exportieren",
            ViewActionDetail: "Bewegungsaktionen Details anzeigen",
            ActionDataExport: "Bewegungsdaten exportieren",
        },
        HomePage: 'Startseite',
        Reinvite: 'Erneut einladen',
        SportDocuments: 'Sportdokumente',
        RegisterSubject: {
            Title: "Bitte vervollständigen Sie Ihr Profil",
            Save: "Profil einreichen",
            From: "Von:",
            Invitation: "der Einladung",
            PlaseEnter: "Bitte eingeben",
        },
        Athletes: {
            TotalCount: "Derzeit insgesamt",
            TotalProjects: "Projekte",
            DeleteNotice: "Möchten Sie den Sportler löschen, der zur Profilergänzung eingeladen wurde?",
            ProjectNameSearch: "Suche nach Sportprojektnamen möglich",
            selectDate: "Datum auswählen",
            CreateTime: "Erstellungsdatum",
            ClickShow: "Klicken zum Ausklappen",
            ClickPutaway: "Klicken zum Einklappen",
            FormarErrorNotice: "(Hinweis: Bis zu einer Dezimalstelle zulässig)",
            EmailNoticeLogin: "E-Mail (zur Anmeldung verfügbar)",
            LoginEmail: "Zur Anmeldung verfügbar",
            Athletes: "Athleten",
            MultipleSelection: "Mehrfachauswahl",
            true: "Mehrfachauswahl",
            false: "Erledigt",
            AddDocuments: "Dokumente hinzufügen",
            TestSystem: "Testsystem (Einzelwahl)",
            Nodata: "Keine Daten verfügbar",
            SportFunction: "Sportfunktionsleistungstestsystem",
            DigitalRunway: "Digitale Laufbahn-Datenerfassungs- und Analysesoftware",
            MuscleStrength: "Muskelkrafttestsystem",
            GolfTechnique: "Golfschwunganalyse",
            Screening: "Filterung",
            GenderLimit: "Geschlecht: unbegrenzt",
            SystemLimit: "System: unbegrenzt",
            TestProject: "Testprojekt",
            Photo: "Foto",
            NextPage: "Nächste Seite",
            PreviousPage: "Vorherige Seite",
            Age: "Alter",
            View: "Anzeigen",
            EditingData: "Daten bearbeiten",
            HistoricalRecord: "Historische Aufzeichnungen",
            SkipPages: "Seiten überspringen",
            AddTestProject: "+ Zum Testprojekt hinzufügen",
            AssociationSportProject: "+ Sportprojekt zuordnen",
            DeldeteDocument: "Dokumente löschen",
            Complete: "Abgeschlossen",
            SearchNotice: "Unterstützt Namenssuche",
            CreateSubject: "Neues Dossier erstellen",
            ModifySubject: "Dossier bearbeiten",
            AddRelationSuccessNotice: "Zuordnung erfolgreich",
            AddRelationFailNotice: "Zuordnung fehlgeschlagen",
            AddRelationNotice: "Bitte wählen Sie das zu zuordnende Projekt aus",
            BaseInfo: "Grundinformationen",
            InviteUsersRegister: "Benutzer zur Registrierung einladen",
            Save: "Speichern",
            Total: "Gesamt",
            Projects: "Projekte: alle aktuell",
            Picture: "Foto",
            PhotoLimitNotice: "Foto begrenzt auf <1MB",
            PhotoLimitNotice2: "Bitte laden Sie ein Foto hoch (<1MB)",
            Name: "Name",
            EnterNotice: "Bitte geben Sie den Namen des Sportlers ein",
            Gneder: "Geschlecht",
            Birthday: "Geburtstag",
            Height: "Größe",
            Weight: "Gewicht",
            EnterWeightNotice: "Bitte geben Sie das Gewicht des Sportlers ein",
            EnterHeightNotice: "Bitte geben Sie die Größe des Sportlers ein",
            PhoneNumber: "Telefonnummer",
            EnterPhoneNumberNotice: "Bitte geben Sie die Telefonnummer ein",
            RequiredNotice: "Darf nicht leer sein",
            PhoneNumberNotice: "Bitte geben Sie ein korrektes Nummernformat ein",
            Email: "E-Mail",
            EnterEmailNotice: "Bitte geben Sie Ihre E-Mail-Adresse ein",
            EmailNotice: "Bitte geben Sie eine korrekte E-Mail-Adresse ein",
            PictureFileNotice: "Bitte wählen Sie eine gültige Bilddatei aus",
            PictureSizeNotice: "Bilddatei muss <1MB sein",
            Manage: "Verwalten",
            Add: "+ Hinzufügen",
            Years: "Jahre",
            FormarError: "Datenformat ungültig",
            ViewDocument: "Dossier anzeigen",
            AddToProject: "Zum Projekt hinzufügen",
            Record: "Aufzeichnung",
            LoadAll: "All Ressourcen geladen",
            Reset: "Zurücksetzen",
            Invationing: "Einladungsprotokoll",
            BatchExportIndicator: "Indikatoren für Massenexport",
            Link: {
                Invitation: "Einladung zur Registrierung",
                FileName: "Dokumentenname",
                LoginEmail: "Registrierungs-E-Mail",
                InvitationLink: "Einladungslink",
                SendInvitation: "Einladung senden",
                CopyLink: "Link kopieren",
                LinkNotice: "Benutzer müssen ihr Profil ergänzen, um das Dossier zu erstellen",
                InvitationOther: "Andere einladen",
                Notice: "Kopieren erfolgreich",
                Notice2: "Kopieren fehlgeschlagen",
                Notice3: "Einladung gesendet",
                Notice4: "Einladung fehlgeschlagen",
                InvationNotice: "Nach Eingabe des Sportlernamens und Klick auf 'Link generieren' wird der Einladungslink direkt an die eingegebene E-Mail gesendet",
                Notice5: "Bitte geben Sie den Namen des Sportlers ein",
            },
            Details: {
                RelationToProject: "Zum Projekt hinzufügen",
                ModifySocument: "Dokument bearbeiten",
                RelationRecord: "Zugehörige Aufzeichnungen",
                None: "Keine",
                SwingSide: "Schlagspieler",
                PowerLeg: "Kraftbein",
                LeftHand: "Linke Hand",
                RightHand: "Rechte Hand",
                LeftLeg: "Linkes Bein",
                RightLeg: "Rechtes Bein",
                Left: "Links",
                Right: "Rechts",
                LeftRight: "Links-Rechts",
                ShoeSize: "Schuhgröße",
                Statistics: "Statistik",
                ClickNotice: "Klicken Sie auf eine Aktion oder Zahl, um Details anzuzeigen",
                Unit: {
                    SwingSide: "Hand",
                    PowerLeg: "Bein",
                    ShoeSize: "Schuhgröße",
                }
            },
            TestRecord: {
                TestRecord: "Testaufzeichnungen",
                StartDate: "Startdatum",
                EndDate: "Enddatum",
                SelectNotice: "Bitte zuerst das Testsystem auswählen",
                Time: "Zeit",
                None: "Keine",
                DataLength: "Aufzeichnungen",
            },
            Result: {
                Application8: {
                    'Swing': "Armschwung",
                    'Akimbo': "Hüftgurt",
                    'Other': "Sonstige",
                    'Bilateral': "Beidseitig",
                    'Left': "Links",
                    'Right': "Rechts",
                    'MidThighPull': "Mittelfemur-Kreuzheben",
                    '1_4Squat': "1/4-Kniebeuge",
                    'CalfRaise': "Wadenheben",
                    'Customization': "Anpassung",
                    'ITest': "I-Test",
                    'YTest': "Y-Test",
                    'TTest': "T-Test",
                    'FreeMode': "Freiemodus",
                    'TimekeepingMode': "Zeitmessermodus",
                    'UpperLimbs': "Oberkörper",
                    'LowerLimbs': "Unterkörper",
                    '动作开始': "Aktion starten",
                    '峰值': "Spitze",
                    '离地': "Abheben",
                    '落地': "Landung",
                    '开始': "Start",
                    '制动': "Bremsen",
                    '最低点': "Tiefpunkt",
                    '落地峰值': "Landungsspitze",
                    '动作结束': "Aktion beenden",
                    '跌落峰值': "Fallspitze",
                    '蹬伸峰值': "Streckenspitze",
                    '左侧最大力值': "Maximalkraft links",
                    '右侧最大力值': "Maximalkraft rechts",
                    '50ms': "50ms",
                    '100ms': "100ms",
                    '150ms': "150ms",
                    '200ms': "200ms",
                    '250ms': "250ms",
                    '300ms': "300ms",
                    'TFmin': "TFmin",
                    'T1': "T1",
                    'TStart': "TStart",
                    'TEnd': "TEnd",
                    'PO': "PO",
                    '触地': "Bodenkontakt",
                    '稳定': "Stabil",
                    '最大垂直力值': "Maximale vertikale Kraft",
                    'A': "A",
                    'B': "B",
                    'C': "C",
                    'D': "D",
                    'E': "E",
                    '制动时刻': "Bremsmoment",
                    '起跳时刻': "Sprungmoment",
                    'Remark': "Bemerkung",
                    '蹬伸': "Strecken",
                    '结束': "Ende",
                    '力': "Kraft",
                    '时间': "Zeit",
                    '速度/加速度': "Geschwindigkeit/Beschleunigung",
                    '功率': "Leistung",
                    '位移': "Verschiebung",
                    '其他': "Sonstige",
                    '冲量': "Impuls",
                    '频率': "Frequenz",
                    '':''
                },
                SendNotice: "Bitte wählen Sie den Sendeinhalt aus",
                SendSuccessfully: "Erfolgreich gesendet",
                EmailContent: "E-Mail-Inhalt",
                SendEmail: "E-Mail senden",
                ReceivingEmail: "Empfangs-E-Mail",
                COPPosition: "COP",
                ModelSetting: "Modulkonfiguration",
                ModelType: "Testmodul",
                L_Fz_COP: "L-COP-Verbindung",
                R_Fz_COP: "R-COP-Verbindung",
                Fz_COP: "Resultantkraft-COP-Verbindung",
                Left: "Links",
                Right: "Rechts",
                Fz: "Resultantkraft",
                COP: "COP-Ansicht",
                AllFz: "Resultantkraft-Fz",
                Legend: "Legende",
                Asi: "Asymmetrieindex",
                LeftRightRatio: "Links-Rechts-Anteil",
                HistoryMax: "Historischer Maximalwert",
                Now: "Aktuell",
                MainIndicators: "Hauptindikatoren",
                OtherIndicators: "Weitere Indikatoren",
                ExtendedIndicators: "Erweiterte Indikatoren",
                SingleView: "Einzelindikatoren",
                NumberOfTimes: "Anzahl",
                NoData: "Nicht gespeicherte Daten",
                GoBack: "Zurück",
                RawData: "Rohdaten herunterladen",
                Export: "Indikatoren exportieren",
                Weight: "Testgewicht",
                Duration: "Testdauer",
                GolfClubs: "Verwendete Golfschläger",
                Spacing: "Standabstand",
                LeftAngle: "Linkswinkel",
                RightAngle: "Rechtswinkel",
                LeftLeg: "Linkes Bein",
                RightLeg: "Rechtes Bein",
                ResultantForce: "Resultantkraft",
                Limbs: "Rumpf",
                Side: "Körperseite",
                Actions: "Bewegungen",
                Pose: "Haltung",
                Order: "Reihenfolge",
                Joint: "Gelenk",
                KneePosition: "Knieposition",
                Times_L: "Anzahl linker Fußtritte",
                Times_R: "Anzahl rechter Fußtritte",
                0: "Standard",
                1: "Links",
                2: "Rechts",
                3: "Zuerst links, dann rechts",
                4: "Zuerst rechts, dann links",
                Unit: {
                    KneePosition: 'CM',
                    Times_L: '',
                    Times_R: '',
                    Spacing: 'CM',
                    Weight: 'KG',
                    Duration: 'S',
                    LeftAngle: '°',
                    RightAngle: '°'
                },
                OnceHeader: "T. Mal",
                ExportReport: "Bericht exportieren",
                Repetitions: "Wiederholungen",
                ContainsPersonalRecords: "Enthält persönliche Aufzeichnungen",
                MuscleStrengthAvgIndicator: {
                    "最大峰值力": "Maximale Spitzenkraft",
                    "平均峰值力": "Mittlere Spitzenkraft",
                    "到达峰值时间": "Zeit bis zur Spitze",
                    "峰值发力率": "Spitzenkraftrate",
                    "峰值力": "Spitzenkraft",
                },
                '左侧最大范围': "Maximalbereich Links",
                '左侧最大范围时间': "Maximalbereichszeit Links",
                '右侧最大范围': "Maximalbereich Rechts",
                '右侧最大范围时间': "Maximalbereichszeit Rechts",
                '左侧平均范围': "Mittlerer Maximalbereich Links",
                '最大范围BSA': "Maximalbereich BSA",
                '右侧平均范围': "Mittlerer Maximalbereich Rechts",
                '最大范围': "Maximalbereich",
                '平均范围': "Mittlerer Maximalbereich",
                '最大范围时间': "Zeit bis zur maximalen Reichweite",
                Times: "Anzahl",
                NumberOfTests:'Testanzahl',
                LeftSide:'Links',
                RightSide:'Rechts',
                数值:"Wert",
                ReferenceValue: 'Referenzwert',
                Internal: 'Innenrotation',
                External: 'Außenrotation',
                Adduction: 'Adduktion',
                Abduction: 'Abduktion',
                Varus: 'Varus',
                Valgus: 'Valgus',
                MaximumForceRatio: 'Maximalkraftverhältnis',
                AvgForce: 'Mittlere Spitzenkraft',
                MaxForce: 'Maximale Spitzenkraft',
                MaxImpulse: 'Maximaler Impuls',
                AvgImpulse: 'Mittlerer Impuls',
                AvgForce_Baseline: 'Mittlere Spitzenkraft (Baseline)',
                MaxForce_Baseline: 'Maximale Spitzenkraft (Baseline)',
                MaxImpulse_Baseline: 'Maximaler Impuls (Baseline)',
                AvgImpulse_Baseline: 'Mittlerer Impuls (Baseline)',
            },
            Action: {
                'Action': "Aktionsdaten",
                'TrendChart': "Trenddiagramm",
                'IndexNotice': "Bitte wählen Sie den Indikator aus",
                'RelationRecord': "Zugehörige Aufzeichnungen",
                'Delete': "Löschen",
                'Export': "Ausgewählte Datensätze exportieren",
                'None': "Keine",
                'ExportData': "Rohdaten exportieren",
                'ExportData1': "Daten exportieren",
                'EcportIndex': "Indikatoren exportieren",
                'ExportReport': "Bericht exportieren",
                'C3DReport': "C3D exportieren",
                'ViewRecord': "Aufzeichnungen anzeigen",
                'Index': "Indikator",
                'Report': "Bericht",
                'Data': "Rohdaten",
                'Total': "Gesamt",
                'Datas': "Datensätze",
                'Max': "Maximalwert",
                'Min': "Minimalwert",
                'Notice': "Bitte zuerst Datensätze auswählen",
                'NoIndex': "Keine Indikatoren verfügbar",
            },
            'SingleCreate': "Manuell hinzufügen",
            'DownloadTemplate': "Importvorlage herunterladen",
            SubjectImportTemplate:"Subjektimportvorlage",
            'ImportFromTemplate': "Massenimport aus Vorlage",
            'Template': "Athleten-Massenimportvorlage",
            'Upload': "Importieren",
            'ImportSuccess': "Import erfolgreich",
            'ImportFailed': "Import fehlgeschlagen",
            'Items': "Einträge",
        },
        SportProjects: {
            'SportProjects': "Sportprojekte",
            'AddSportProjectNotice': "Sportprojekte dienen nur zur Unterscheidung von Athleten",
            'ProjectName': "Projektname",
            'AddProject': "Projekt hinzufügen",
            'RelatedCount': "Anzahl der zugehörigen Personen",
            'Operate': "Operation",
            'RelatedAthletes': "Zugehörige Athleten",
            'AddSportProject': "Sportprojekt hinzufügen",
            'notice1': "Bitte mindestens eine auswählen",
            'SelectApplications': "Anwendungssysteme",
            'ProNameNotice': "Sportprojektname eingeben",
            'addSuccessNotice': "Sportprojekt erfolgreich hinzugefügt",
            'addFaildNotice': "Sportprojekt hinzufügen fehlgeschlagen",
            'deleteSuccessNotice': "Sportprojekt erfolgreich gelöscht",
            'deleteFaildNotice': "Sportprojekt löschen fehlgeschlagen",
            'updateSuccessNotice': "Sportprojekt erfolgreich aktualisiert",
            'updateFaildNotice': "Sportprojekt aktualisieren fehlgeschlagen",
            'CreateSportProject': "Sportprojekt erstellen",
            'EmptyNotice': "Bitte geben Sie den Projektnamen ein",
            'People': "Personen",
            'Name': "Name",
            'Gender': "Geschlecht",
            'Birthday': "Geburtstag",
            'ModifyName': "Ändern",
            'ModifySportProject': "Sportprojekt bearbeiten",
            'modifySuccessNotice': "Projektname erfolgreich geändert",
            'modifyFaildNotice': "Projektname darf nicht wiederholt werden",
            'AddSport': "Athleten verwalten",
            'Athletes': "Athleten",
            'QueryError': "Abfrage fehlgeschlagen",
            'Added': "Bereits hinzugefügt",
            'SaveFailNotice': "Speichern fehlgeschlagen",
            'SaveSuccessNotice': "Speichern erfolgreich",
            'NotSaved': "Inhalte nicht gespeichert. Möchten Sie die Seite dennoch verlassen?",
            'DeleteNotice': "Möchten Sie dieses Sportprojekt löschen?",
            'Notice': "Hinweis",
            'DeleteProjcctNotice': "Sportprojekt löschen",
        }
    },
    Application: {
        Name: {
            1: "Muskelkrafttestsystem",
            5: "Golfschwunganalyse-System",
            6: "Hamstring-Testsystem",
            7: "Multifunktionales Kraftmessgerüst",
            8: "Sportfunktionsleistungstestsystem",
            9: "Gelenkbeweglichkeit",
        },
        Label: {
            Detail: "Details anzeigen",
            SubjectCount: "Athleten",
            RecordCount: "Testaufzeichnungen",
            ProjectCount: "Testprojekte",
            RankList: "Ranglistenanzeige",
            More: "Mehr >",
            TrendCharts: "Testtrends",
            Indicators: "Indikatoren",
            ExportIndicators: "Indikatoren exportieren",
            TrainingPlan: "Trainingsplan",
            MostRecentRecord: "Letzte Aufzeichnung",
            AllRecords: "Alle Aufzeichnungen",
        },
        Options: {
            LastDays: "Letzte %d Tage",
        },
        Columns: {
            "CreateTime": "Erstellungsdatum",
        },
    },
    Report: {
        Label: {
            MinAvgMax: "Min/Max",
            ReportChart: "Berichtsdiagramm",
            Query: "Filterung",
            Export: "Exportieren",
            IndicatorOptions: "Indikatorfilterung",
            SubjectOptions: "Athletenauswahl",
            MaxValue: "Maximalwert auswählen",
            MinValue: "Minimalwert auswählen",
            InsertChart: "Diagramm hinzufügen",
            ModifyChart: "Diagramm bearbeiten",
            true: "Maximalwert auswählen",
            false: "Minimalwert auswählen",
            指标:'Indikator',
            值:'Wert',
            单位:'Einheit'
        },
        Message: {
            IndicatorsEmpty: "Bitte wählen Sie einen Indikator aus",
            SubjectEmpty: "Bitte wählen Sie einen Athleten aus",
        },
        Indicators: {
            '峰值': "Spitze",
            '峰值时间': "Spitzenzeit",
            '最大发力率': "Maximale Kraftentwicklung",
            '最大峰值力': "Maximale Spitzenkraft",
            '平均峰值力': "Mittlere Spitzenkraft",
            '到达峰值时间': "Zeit bis zur Spitze",
            '峰值发力率': "Spitzenkraftentwicklung",
            '左脚平均峰值力': "Mittlere Spitzenkraft linker Fuß",
            '右脚平均峰值力': "Mittlere Spitzenkraft rechter Fuß",
            '左脚最大力值': "Maximalkraft linker Fuß",
            '右脚最大力值': "Maximalkraft rechter Fuß",
            '左脚重复次数': "Wiederholungen linker Fuß",
            '右脚重复次数': "Wiederholungen rechter Fuß",
            '左重复次数': "Wiederholungen links",
            '右重复次数': "Wiederholungen rechts",
            '内收左重复次数': "Wiederholungen Adduktion links",
            '内收右重复次数': "Wiederholungen Adduktion rechts",
            '外展左重复次数': "Wiederholungen Abduktion links",
            '外展右重复次数': "Wiederholungen Abduktion rechts",
            '内旋左重复次数': "Wiederholungen Innenrotation links",
            '内旋右重复次数': "Wiederholungen Innenrotation rechts",
            '外旋左重复次数': "Wiederholungen Außenrotation links",
            '外旋右重复次数': "Wiederholungen Außenrotation rechts",
            '内翻左重复次数': "Wiederholungen Varus links",
            '内翻右重复次数': "Wiederholungen Varus rechts",
            '外翻左重复次数': "Wiederholungen Valgus links",
            '外翻右重复次数': "Wiederholungen Valgus rechts",
            '左最大力值': "Maximalkraft links",
            '右最大力值': "Maximalkraft rechts",
            '内收左最大力值': "Maximalkraft Adduktion links",
            '内收右最大力值': "Maximalkraft Adduktion rechts",
            '外展左最大力值': "Maximalkraft Abduktion links",
            '外展右最大力值': "Maximalkraft Abduktion rechts",
            '内旋左最大力值': "Maximalkraft Innenrotation links",
            '内旋右最大力值': "Maximalkraft Innenrotation rechts",
            '外旋左最大力值': "Maximalkraft Außenrotation links",
            '外旋右最大力值': "Maximalkraft Außenrotation rechts",
            '内翻左最大力值': "Maximalkraft Varus links",
            '内翻右最大力值': "Maximalkraft Varus rechts",
            '外翻左最大力值': "Maximalkraft Valgus links",
            '外翻右最大力值': "Maximalkraft Valgus rechts",
            '左脚扭矩': "Drehmoment linker Fuß",
            '右脚扭矩': "Drehmoment rechter Fuß",
            '左脚峰值力最大值': "Maximale Spitzenkraft linker Fuß",
            '右脚峰值力最大值': "Maximale Spitzenkraft rechter Fuß",
            '峰值力最大值BSA': "Maximale Spitzenkraft BSA",
            '左脚峰值力平均值': "Mittlere Spitzenkraft linker Fuß",
            '右脚峰值力平均值': "Mittlere Spitzenkraft rechter Fuß",
            '峰值力平均值BSA': "Mittlere Spitzenkraft BSA",
            '左脚冲量平均值': "Mittlerer Impuls linker Fuß",
            '右脚冲量平均值': "Mittlerer Impuls rechter Fuß",
            '冲量平均值BSA': "Mittlerer Impuls BSA",
            '左脚冲量最大值': "Maximaler Impuls linker Fuß",
            '右脚冲量最大值': "Maximaler Impuls rechter Fuß",
            '冲量最大值BSA': "Maximaler Impuls BSA",
            '最大相对力值': "Maximale relative Kraft",
            '合力最大力值': "Maximalkraft der Resultantkraft",
            '左侧最大力值': "Maximalkraft links",
            '右侧最大力值': "Maximalkraft rechts",
            '平均功率': "Mittlere Leistung",
            '相对平均功率': "Relative mittlere Leistung",
            '峰值功率': "Spitzenleistung",
            '相对峰值功率': "Relative Spitzenleistung",
            '峰值功率发生时刻': "Zeitpunkt der Spitzenleistung",
            '峰值功率发生时速度': "Geschwindigkeit bei Spitzenleistung",
            '向心阶段冲量': "Impuls der Zentrifugalphase",
            '向心最大速度': "Maximale Zentripetalgeschwindigkeit",
            '缓冲最小相对力值': "Minimale relative Kraft im Puffer",
            '峰值力发力率': "Spitzenkraftentwicklung",
            '起跳速度': "Sprunggeschwindigkeit",
            '腾空时间': "Flugdauer",
            '腾空高度v': "Schwebenhöhe v",
            '腾空高度Ft': "Schwebenhöhe Ft",
            '腾空高度t': "Schwebenhöhe t",
            '下蹲时间': "Hockzeit",
            '制动时间': "Bremszeit",
            '蹬伸时间': "Streckzeit",
            '触地时间': "Bodenkontaktzeit",
            '反应力量指数RSI': "Reaktiver Kraftindex RSI",
            '反应力量指数RSImod': "Modifizierter reaktiver Kraftindex RSImod",
            '蹬伸与制动时间比T': "Verhältnis Streckzeit/Bremszeit T",
            '蹬伸最大功率%': "Maximale Streckleistung %",
            '蹬伸最大力值%': "Maximale Streckkraft %",
            '落地最大力值':'Maximale Landekraft',
            '落地最大力值%': "Maximale Landekraft %",
            '合力最大力值DSI': "Resultantkraft Maximalkraft DSI",
            '左侧最大力值DSI': "Maximalkraft links DSI",
            '右侧最大力值DSI': "Maximalkraft rechts DSI",
            '腾空高度EUR': "Schwebenhöhe EUR",
            '最大蹬伸力发力率': "Maximale Streckkraftentwicklung",
            '跌落相对峰值力': "Relative Spitzenkraft Fall",
            '蹬伸相对峰值力': "Relative Spitzenkraft Streck",
            '蹬伸相对最大功率': "Relative maximale Streckleistung",
            '腾空速度': "Schwebegeschwindigkeit",
            '蹬伸峰值加速度': "Streckspitzenbeschleunigung",
            '跌落峰值%': "Fallspitzen %",
            '跌落峰值加载率%': "Fallspitzen-Ladungsrate %",
            '蹬伸峰值%': "Streckspitzen%",
            '蹬伸峰值加载率%': "Streckspitzen-Ladungsrate%",
            '相对最大力值': "Relative maximale Kraft",
            '到达最大力值时间': "Zeit bis zur maximalen Kraft",
            '左侧到达最大力值时间': "Zeit bis zur maximalen Kraft links",
            '右侧到达最大力值时间': "Zeit bis zur maximalen Kraft rechts",
            '50ms冲量': "50ms Impuls",
            '100ms冲量': "100ms Impuls",
            '150ms冲量': "150ms Impuls",
            '200ms冲量': "200ms Impuls",
            '250ms冲量': "250ms Impuls",
            '300ms冲量': "300ms Impuls",
            '50ms RFD': "50ms RFD",
            '100ms RFD': "100ms RFD",
            '150ms RFD': "150ms RFD",
            '200ms RFD': "200ms RFD",
            '250ms RFD': "250ms RFD",
            '300ms RFD': "300ms RFD",
            '最大合力时刻分量%': "Maximalkraft-Momentkomponente%",
            '最大力值%': "Maximalkraft%",
            '最大力值时间%': "Maximalkraftzeit%",
            '单位体重最大力值': "Maximalkraft pro Körpergewicht",
            '平均缓冲最大相对力值': "Mittlere maximale relative Kraft im Puffer",
            '平均蹬伸最大相对力值': "Mittlere maximale relative Kraft im Strecken",
            '平均缓冲时间': "Mittlere Pufferzeit",
            '平均蹬伸时间': "Mittlere Streckzeit",
            '平均触地时间': "Mittlere Bodenkontaktzeit",
            '平均腾空时间': "Mittlere Flugdauer",
            '6_7': "Mittlere Schwebenhöhe",
            '平均反应力量指数RSI': "Mittlerer reaktiver Kraftindex RSI",
            '平均反应力量指数RSImod': "Mittlerer modifizierter reaktiver Kraftindex RSImod",
            '蹬伸平均最大力值%': "Mittlere maximale Streckkraft%",
            '缓冲平均最大力值%': "Mittlere maximale Pufferkraft%",
            '缓冲加载率%': "Pufferladungsrate%",
            '平均起跳速度': "Mittlere Sprunggeschwindigkeit",
            '平均峰值功率': "Mittlere Spitzenleistung",
            '蹲起时间': "Hock-/Streckzeit",
            '绝对最大力值': "Absolute Maximalkraft",
            '缓冲相对最大力值': "Relative maximale Pufferkraft",
            '缓冲相对最小力值': "Relative minimale Pufferkraft",
            '蹬伸相对最大力值': "Relative maximale Streckkraft",
            '相对最大功率': "Relative maximale Leistung",
            '下蹲和蹬伸时间比': "Verhältnis Hockzeit/Streckzeit",
            '相对最大力值%': "Relative maximale Kraft%",
            '相对最大功率%': "Relative maximale Leistung%",
            '总计次数': "Gesamtanzahl",
            '频率': "Frequenz",
            '初段平均频率': "Mittlere Frequenz (Anfangsphase)",
            '中段平均频率': "Mittlere Frequenz (Mittelsequenz)",
            '末段平均频率': "Mittlere Frequenz (Endsequenz)",
            '耐力指数': "Ausdauerindex",
            '疲劳指数': "Ermüdungsindex",
            '最小自由频率': "Minimale freie Frequenz",
            '最大自由频率': "Maximale freie Frequenz",
            '相对峰值平均值%': "Mittlere relative Spitzenkraft%",
            '落地峰值': "Landungsspitze",
            '落地到恢复稳定时间': "Zeit von Landung bis zur stabilen Erholung",
            '前后摇晃最大幅度': "Maximale Schwingungsamplitude vor/rückwärts",
            '左右摇晃最大幅度': "Maximale Schwingungsamplitude links/rechts",
            '总体平均摇晃速度': "Mittlere Gesamtschwingungsgeschwindigkeit",
            '前后平均摇晃速度': "Mittlere Schwingungsgeschwindigkeit vor/rückwärts",
            '左右平均摇晃速度': "Mittlere Schwingungsgeschwindigkeit links/rechts",
            '落地峰值力%': "Landungsspitzenkraft%",
            '落地恢复时间%': "Landungserholungszeit%",
            '左右摇晃轨迹长度': "Schwingungstrajectallänge links/rechts",
            '前后摇晃轨迹长度': "Schwingungstrajectallänge vor/rückwärts",
            '总体摇晃轨迹长度': "Gesamtschwingungstrajectallänge",
            '轨迹包络面积': "Trajektorienumfangsfläche",
            '最大净力值': "Maximale Nettokraft",
            '发力率50ms': "Kraftentwicklungsrate 50ms",
            '发力率100ms': "Kraftentwicklungsrate 100ms",
            '发力率150ms': "Kraftentwicklungsrate 150ms",
            '发力率200ms': "Kraftentwicklungsrate 200ms",
            '发力率250ms': "Kraftentwicklungsrate 250ms",
            '发力率300ms': "Kraftentwicklungsrate 300ms",
            '腾空高度': "Schwebenhöhe",
            '上箱高度': "Boxhöhe",
            '离心制动阶段发力率': "Kraftentwicklungsrate in der exzentrischen Bremsphase",
            '离心制动阶段冲量': "Impuls in der exzentrischen Bremsphase",
            '落地稳定时间': "Stabilisierungszeit nach Landung",
            '下蹲深度': "Hocktiefe",
            '下蹲平均速度': "Mittlere Hockgeschwindigkeit",
            '预拉伸增强百分比PSAP': "Vordehnungsverstärkungsprozentsatz PSAP",
            '弹性指数ESI': "Elastizitätsindex ESI",
            '落地表现指数': "Landungsleistungsindex",
            '左侧跌落峰值力': "Linker Fall-Spitzenkraft",
            '右侧跌落峰值力': "Rechter Fall-Spitzenkraft",
            '左侧跌落峰值力加载率': "Linker Fall-Spitzenkraft-Ladungsrate",
            '右侧跌落峰值力加载率': "Rechter Fall-Spitzenkraft-Ladungsrate",
            '跌落峰值力发力率': "Fall-Spitzenkraft-Entwicklungsrat",
            '离心阶段冲量': "Exzentrische Phase Impuls",
            '跌落峰值力到达时间': "Fall-Spitzenkraft Ankunftszeit",
            '左侧跌落峰值力到达时间': "Linker Fall-Spitzenkraft Ankunftszeit",
            '右侧跌落峰值力到达时间': "Rechter Fall-Spitzenkraft Ankunftszeit",
            '落地峰值力': "Landungsspitzenkraft",
            '落地峰值力加载率': "Landungsspitzenkraft-Ladungsrate",
            '落地峰值力到达时间': "Landungsspitzenkraft Ankunftszeit",
            '左侧落地峰值力': "Linker Landungsspitzenkraft",
            '右侧落地峰值力': "Rechter Landungsspitzenkraft",
            '左侧落地峰值力加载率': "Linker Landungsspitzenkraft-Ladungsrate",
            '右侧落地峰值力加载率': "Rechter Landungsspitzenkraft-Ladungsrate",
            '左侧落地峰值力到达时间': "Linker Landungsspitzenkraft Ankunftszeit",
            '右侧落地峰值力到达时间': "Rechter Landungsspitzenkraft Ankunftszeit",
            '触地时间差': "Bodenkontaktzeitunterschied",
            '落地顺序': "Landungsreihenfolge",
            '平均下蹲速度': "Mittlere Hockgeschwindigkeit",
            '平均下蹲深度': "Mittlere Hocktiefe",
            '缓冲最大相对力值': "Maximale relative Kraft im Puffer",
            '蹬伸最大相对力值': "Maximale relative Kraft im Strecken",
            '缓冲时间': "Pufferzeit",
            '下蹲速度': "Hockgeschwindigkeit",
            '蹬伸时刻': "Streckzeitpunkt",
            '频率FRE': "Frequenz FRE",
            '初段平均频率FRE1': "Mittlere Frequenz FRE1 (Anfangsphase)",
            '中段平均频率FRE2': "Mittlere Frequenz FRE2 (Mittelsequenz)",
            '末段平均频率FRE3': "Mittlere Frequenz FRE3 (Endsequenz)",
            '左右腿相对峰值平均值%': "Mittlere relative Spitzenkraft links/rechts %",
            '左右平均腿腾空时间%': "Mittlere Flugdauer links/rechts %",
            '左右平均腿触地时间%': "Mittlere Bodenkontaktzeit links/rechts %",
            '左侧最大范围': "Maximalbereich links",
            '左侧平均范围': "Mittlerer Maximalbereich links",
            '右侧最大范围': "Maximalbereich rechts",
            '右侧平均范围': "Mittlerer Maximalbereich rechts",
            '最大范围BSA': "Maximalbereich BSA",
            '最大范围': "Maximalbereich",
            '平均范围': "Mittlerer Maximalbereich",
            '平均腾空高度': "Mittlere Schwebenhöhe",
            '峰值力': "Spitzenkraft",
            '平均力': "Mittlere Kraft",
            '冲量I': "Impuls I",
            '峰值力对称性%': "Spitzenkraft-Symmetrie %",
            '最小力值对称性%': "Minimalkraft-Symmetrie %",
            '冲量对称性%': "Impuls-Symmetrie %",
        }
    },
    UserManagement: {
        Label: {
            Member: "Mitglied",
            Disabled: "Deaktivierter Benutzer",
            SelectRole: "Rolle auswählen",
            SelectGroup: "Berechtigungsgruppe auswählen",
            FilterByAccountName: "Nach Benutzername oder Kontoname suchen",
            BatchOperate: "Massenverarbeitung",
            CreateAccount: "Benutzer erstellen",
            Enanble: "Benutzer wiederherstellen",
            Disable: "Benutzer deaktivieren",
            Delete: "Vollständig löschen",
            Permission: "Berechtigung",
            Information: "Informationen bearbeiten",
            Role: "Rolle",
            PermissionGroup: "Berechtigungsgruppe",
            DefaultGroup: "Standardgruppe",
            Account: "Benutzername",
            Password: "Passwort",
            Name: "Name",
            ModifyPermission: "Berechtigungen ändern",
            ModifyAccountInfo: "Benutzerinformationen ändern",
            Prev: "Vorherige Seite",
            Next: "Nächste Seite",
            CreateConfirm: "Benutzer erstellen",
        },
        Columns: {
            AvatarAccount: "Avatar/Benutzername",
            UserName: "Name",
            CreateTime: "Erstellungsdatum",
            RolePermission: "Rolle/Berechtigung",
            Operate: "Operation",
        },
        Message: {
            LengthNotice: "Geben Sie bitte 8 bis 16 Zeichen ein",
            AccountFillNotice: "Passwort muss E-Mail-Format haben",
            ConfirmDisable: "Bestätigen Sie, dass Sie diesen Benutzer deaktivieren möchten?",
            ConfirmEnable: "Bestätigen Sie, dass Sie diesen Benutzer reaktivieren möchten?",
            ConfirmDelete: "Bestätigen Sie, dass Sie diesen Benutzer vollständig löschen möchten?",
            ConfirmPermissionModify: "Bestätigen Sie, dass Sie die Berechtigungen dieses Benutzers ändern möchten?",
            ConfirmModifyAccountInfo: "Bestätigen Sie, dass Sie speichern möchten?",
            PermissionModifySuccess: "Berechtigungen wurden erfolgreich geändert",
            PWNotice: "Passwort darf nicht leer sein",
            NameNotice: "Name darf nicht leer sein",
        }
    },
    Role: {
        0: "Athleten",
        1: "Trainer",
        63: "Administrator",
        127: "Betriebspersonal",
        255: "Superadministrator",
        Subject: "Athleten",
        Coach: "Trainer",
        Admin: "Administrator",
        OM: "Betriebspersonal",
    },
    Gender: {
        0: "Männlich",
        1: "Weiblich",
    },
    ActionModel: {
        RecordCount: "Datensatzanzahl",
        ProjectCount: "Projektanzahl",
        Nordic: "Skandinavisch",
        Razor: "Rasiermesserrahmen",
        IsometricContraction_0: "Isometrische Kontraktion 0°",
        IsometricContraction_30: "Isometrische Kontraktion 30°",
        IsometricContraction_60: "Isometrische Kontraktion 60°",
        Irons: "Ironen",
        Woods: "Holzschläger",
        Wedges: "Wedges",
        Hybrids: "Hybrid-Schläger",
        Putter: "Putter",
        Iron1: "Iron 1",
        Iron2: "Iron 2",
        Iron3: "Iron 3",
        Iron4: "Iron 4",
        Iron5: "Iron 5",
        Iron6: "Iron 6",
        Iron7: "Iron 7",
        Iron8: "Iron 8",
        Iron9: "Iron 9",
        Iron10: "Iron 10",
        Driver: "Driver",
        Wood3: "Holz 3",
        Wood5: "Holz 5",
        Wood7: "Holz 7",
        Wood9: "Holz 9",
        Pitch: "Pitch",
        Wedge48: "Wedge 48°",
        Wedge50: "Wedge 50°",
        Wedge52: "Wedge 52°",
        Wedge54: "Wedge 54°",
        Wedge56: "Wedge 56°",
        Wedge58: "Wedge 58°",
        Wedge60: "Wedge 60°",
        Wedge62: "Wedge 62°",
        Hybrid1: "Hybrid 1",
        Hybrid2: "Hybrid 2",
        Hybrid3: "Hybrid 3",
        Hybrid4: "Hybrid 4",
        Hybrid5: "Hybrid 5",
        Hybrid6: "Hybrid 6",
        Hybrid7: "Hybrid 7",
        '1': "Nacken",
        '2': "Vornüberbeugen",
        '3': "Rückwärtsbeugen",
        '4': "Nach links beugen",
        '5': "Nach rechts beugen",
        '6': "Sitzposition",
        '7': "Sitzposition",
        '8': "Sitzposition",
        '9': "Sitzposition",
        '10': "Schulter",
        '11': "Links",
        '12': "Rechts",
        '13': "Innenrotation",
        '14': "Außenrotation",
        '15': "Adduktion",
        '16': "Abduktion",
        '17': "Flexion",
        '18': "Extension",
        '19': "ISO I-Test",
        '20': "ISO Y-Test",
        '21': "ISO T-Test",
        '22': "Sitzposition - 90° Ellenbogenbeugung",
        '23': "Sitzposition - 90° Ellenbogenbeugung 90° Schulterabduktion",
        '24': "Stehposition - 90° Ellenbogenbeugung",
        '25': "Stehposition - 90° Ellenbogenbeugung 90° Schulterabduktion 90° Schulteraußenrotation",
        '26': "Rückenlage - 90° Ellenbogenbeugung 90° Schulterabduktion",
        '27': "Rückenlage - 90° Ellenbogenbeugung",
        '28': "Bauchlage",
        '29': "Sitzposition - 90° Ellenbogenbeugung",
        '30': "Sitzposition 90° Ellenbogenbeugung 90° Schulterabduktion",
        '31': "Stehposition - 90° Ellenbogenbeugung",
        '32': "Stehposition - 90° Ellenbogenbeugung - 90° Schulterabduktion",
        '33': "Rückenlage - 90° Ellenbogenbeugung - 90° Schulterabduktion",
        '34': "Rückenlage - 90° Ellenbogenbeugung",
        '35': "Bauchlage",
        '36': "Sitzposition",
        '37': "Stehposition",
        '38': "Sitzposition",
        '39': "Stehposition",
        '40': "Seitenlage",
        '41': "Sitzposition - 90° Schulterabduktion",
        '42': "Stehposition",
        '43': "Stehposition - 90° Ellenbogenbeugung",
        '44': "Sitzposition",
        '45': "Stehposition",
        '46': "Sitzposition - 90° Schulterbeugung",
        '47': "Stehposition - 90° Schulterbeugung",
        '48': "Rückenlage",
        '49': "Rückenlage",
        '50': "Bauchlage",
        '51': "Rückenlage",
        '52': "Bauchlage",
        '53': "Rückenlage",
        '54': "Bauchlage",
        '55': "Rumpf",
        '56': "Vornüberbeugen",
        '57': "Nach links beugen",
        '58': "Nach rechts beugen",
        '59': "Sitzposition",
        '60': "Sitzposition",
        '61': "Sitzposition",
        '62': "Hüfte",
        '63': "Links",
        '64': "Rechts",
        '65': "Flexion",
        '66': "Extension",
        '67': "Innenrotation",
        '68': "Außenrotation",
        '69': "Adduktion",
        '70': "Abduktion",
        '71': "Stehposition",
        '72': "Bauchlage",
        '73': "Bauchlage - 90° Kniebeugung",
        '74': "Halb-Bauchlage",
        '75': "Stehposition",
        '76': "Rückenlage",
        '77': "Sitzposition",
        '78': "Sitzposition",
        '79': "Rückenlage",
        '80': "Bauchlage",
        '81': "Sitzposition",
        '82': "Rückenlage",
        '83': "Bauchlage",
        '84': "Rückenlage",
        '85': "Rückenlage - 45° Kniebeugung",
        '86': "Rückenlage - 90° Ellenbogenbeugung",
        '87': "Rückenlage",
        '88': "Rückenlage - 45° Kniebeugung",
        '89': "Rückenlage - 90° Ellenbogenbeugung",
        '90': "Seitenlage",
        '91': "Ellenbogen",
        '92': "Links",
        '93': "Rechts",
        '94': "Flexion",
        '95': "Extension",
        '96': "Sitzposition - 90° Ellenbogenbeugung - Handgelenk neutral",
        '97': "Sitzposition - 90° Ellenbogenbeugung - Handgelenk proniert",
        '98': "Sitzposition - 90° Ellenbogenbeugung - Handgelenk supiniert",
        '99': "Sitzposition - 90° Ellenbogenbeugung 90° Schulterabduktion - Handgelenk neutral",
        '100': "Sitzposition - 90° Ellenbogenbeugung 90° Schulterabduktion - Handgelenk proniert",
        '101': "Stehposition - 90° Ellenbogenbeugung - Handgelenk neutral",
        '102': "Sitzposition - 90° Ellenbogenbeugung",
        '103': "Handgelenk",
        '104': "Links",
        '105': "Rechts",
        '106': "Supination",
        '107': "Pronation",
        '108': "Flexion",
        '109': "Extension",
        '110': "Ulnardeviation",
        '111': "Radialdeviation",
        '112': "90° Ellenbogenbeugung - Handgelenk neutral",
        '113': "90° Ellenbogenbeugung - Handgelenk neutral",
        '114': "90° Ellenbogenbeugung - Handgelenk neutral",
        '115': "90° Ellenbogenbeugung - Handgelenk neutral",
        '116': "90° Ellenbogenbeugung - Handgelenk neutral",
        '117': "90° Ellenbogenbeugung - Handgelenk proniert",
        '118': "90° Ellenbogenbeugung - Handgelenk supiniert",
        '119': "90° Ellenbogenbeugung - Handgelenk neutral",
        '120': "90° Ellenbogenbeugung - Handgelenk proniert",
        '121': "90° Ellenbogenbeugung - Handgelenk supiniert",
        '122': "Hand",
        '123': "Links",
        '124': "Rechts",
        '125': "Greifkraft",
        '126': "Sitzposition - 90° Ellenbogenbeugung - Handgelenk neutral",
        '127': "Sitzposition - Handgelenk neutral",
        '128': "Sitzposition - 90° Schulterbeugung - Handgelenk neutral",
        '129': "Knie",
        '130': "Links",
        '131': "Rechts",
        '132': "Flexion",
        '133': "Extension",
        '134': "Sitzposition",
        '135': "Bauchlage",
        '136': "Rückenlage",
        '137': "Sitzposition - 90° Kniebeugung",
        '138': "Bauchlage - 90° Kniebeugung",
        '139': "Rückenlage",
        '140': "Sprunggelenk",
        '141': "Links",
        '142': "Rechts",
        '143': "Inversion",
        '144': "Eversion",
        '145': "Dorsalextension",
        '146': "Plantarflexion",
        '147': "Sitz mit gestreckten Knien",
        '148': "Sitz mit gestreckten Knien",
        '149': "Sitz mit gestreckten Knien",
        '150': "Sitz mit gestreckten Knien",
        '151': "Fuß",
        '152': "Links",
        '153': "Rechts",
        '154': "Zehenbeugung",
        '155': "Zehenstreckung",
        '156': "Sitzposition",
        '157': "Sitz mit gestreckten Knien - Plantarflexion",
        '158': "Sitz mit gestreckten Knien - neutrale Plantarposition",
        '159': "Sitzposition",
        '160': "Sitz mit gestreckten Knien - neutrale Plantarposition",
        '161': "Sitz mit gestreckten Knien - Plantarflexion",
        '162': "Stehposition",
        '163': "Rückenlage",
        '164': "Stehposition",
        '165': "Rückenlage",
        '166': "Stehposition",
        '167': "Rückenlage",
        '168': "Stehposition",
        '169': "Rückenlage",
        '170': "Seitenlage",
        '171': "Seitenlage",
        '172': "Schulterblatt-Elevation",
        '173': "Schulterblatt-Protraktion",
        '174': "Schulterblatt-Retraktion",
        '175': "Sitzposition",
        '176': "Sitzposition",
        '177': "Sitzposition",
        '178': "Sitzposition - 90° Ellenbogenbeugung",
        '179': "Stehposition - 90° Ellenbogenbeugung",
        '180': "Rückenlage - 90° Ellenbogenbeugung",
        '181': "Sitzposition - 90° Ellenbogenbeugung",
        '182': "Stehposition - 90° Ellenbogenbeugung",
        '183': "Bauchlage",
        '184': "Sitzposition - 90° Schulterabduktion",
        '185': "Sitzposition - 90° Schulterabduktion - 90° Ellenbogenbeugung",
        '186': "Sitzposition - 90° Schulterabduktion",
        '187': "Sitzposition - 90° Schulterabduktion - 90° Ellenbogenbeugung",
        '188': "Stehposition - 90° Ellenbogenbeugung",
        '189': "Seitenlage - 90° Ellenbogenbeugung",
        '190': "Sitzposition - 90° Ellenbogenbeugung 90° Schulterabduktion 90° Schulteraußenrotation",
        '191': "Sitzposition - 90° Ellenbogenbeugung 90° Schulterabduktion 90° Schulteraußenrotation",
        '192': "Seitenlage - 90° Ellenbogenbeugung",
        '193': "Stehposition - 90° Ellenbogenbeugung - Handgelenk proniert",
        '194': "Stehposition - 90° Ellenbogenbeugung - Handgelenk supiniert",
        '195': "Stehposition - 90° Ellenbogenbeugung",
        '197': "Sonstiges",
        '198': "Stehposition - 90° Kniebeugung",
        '199': "Sitzposition - 45° Kniebeugung",
        '200': "Halb-Rückenlage",
        '201': "Bauchlage - 45° Kniebeugung",
        '205': "Deadlift an der Oberschenkelmitte",
        '206': "Stehposition",
        '207': "Stehposition - 90° Ellenbogenbeugung - Handgelenk supiniert",
        '208': "Stehposition - 90° Ellenbogenbeugung - Handgelenk proniert",
        'Hip_Joint': "Hüftgelenk",
        'Buckling': "Flexion",
        'Stand_Straight': "Stehposition mit gestreckten Beinen",
        'Stand_Knees_Kick': "Stehposition mit Kniebeugung und Tritt",
        'Stomach_Knees_30': "Bauchlage - 30° Kniebeugung",
        'Sit_Knees_90': "Sitzposition - 90° Kniebeugung",
        'Back_Knees_90': "Rückenlage - 90° Kniebeugung",
        'Spread': "Extension",
        'Stomach_Knees_Thigh': "Bauchlage - 90° Kniebeugung - Oberschenkelrückseite",
        'Stand_Upright_Ankle': "Stehposition mit gestreckten Beinen - Sprunggelenk",
        'Adduction_Abduction': "Adduktion/Abduktion",
        'Back_Knees_120': "Rückenlage - 120° Kniebeugung",
        'Back_Knees_135': "Rückenlage - 135° Kniebeugung",
        'Stance_Ankles': "Stehposition - Sprunggelenk",
        'Standing_Knees': "Stehposition - Knie",
        'Back_Ankles': "Rückenlage - Sprunggelenk",
        'Back_Knees': "Rückenlage - Knie",
        'Internal_External': "Innenrotation/Außenrotation",
        'Stomach_Knees_90': "Bauchlage - 90° Kniebeugung",
        'Knee_Joint': "Kniegelenk",
        'Stomach_Knees_45': "Bauchlage - 45° Kniebeugung",
        'Stand_Knees_90': "Stehposition - 90° Kniebeugung",
        'Back_Knees_45': "Rückenlage - 45° Kniebeugung",
        'Sit_Knees_10': "Sitzposition - 10° Kniebeugung",
        'Sit_Knees_45': "Sitzposition - 45° Kniebeugung",
        'Back_Knees_10': "Rückenlage - 10° Kniebeugung",
        'Ankle_Joint': "Sprunggelenk",
        'Dorsiflexion': "Dorsalextension",
        'Sitting_Position': "Sitzposition",
        'Varus_Valgus': "Inversion/Eversion",
        'Back_StraightLegs': "Rückenlage mit gestreckten Beinen",
        'Toe_Flexion': "Zehenbeugung",
        'Lie_Supine': "Rückenlage",
        'Shoulder_Joint': "Schultergelenk",
        'Stomach_Straight': "Bauchlage mit gestreckten Armen",
        'Abduction': "Abduktion",
        'Side_Straight': "Seitenlage - gestreckte Arme",
        'Adduction': "Adduktion",
        'Shoulder_Elbow': "Rückenlage - 90° Schulterabduktion - 90° Ellenbogenbeugung",
        'Elbow_Neutral': "Rückenlage - 90° Ellenbogenbeugung - neutrale Ellenbogenposition",
        'Articulatio_Cubiti': "Ellenbogengelenk",
        'Sit_Elbows_90': "Sitzposition - 90° Ellenbogenbeugung",
        'Neck': "Nacken",
        'Default_Position': "Standardposition",
        'Lateral_Flexion': "Lateralflexion",
        'Default': "Standard",
        'Left': "Links",
        'Right': "Rechts",
        'Left_To_Right': "Links zuerst, dann Rechts",
        'Right_To_Left': "Rechts zuerst, dann Links",
        'simultaneously': "Links und Rechts gleichzeitig",
        'Null': "Keine",
        'CMJ': "Kniebeuge-Sprung",
        'SJ': "Sprung aus der Hocke",
        'DropJump': "Fall-Sprung",
        'MVC': "Maximale willkürliche Kontraktion",
        'RepetitiveHopping': "Kontinuierliche Sprünge mit gestreckten Beinen",
        'RepetitiveCMJ': "Kontinuierliche Kniebeuge-Sprünge",
        'Squat': "Kniebeugen",
        'Stamping': "Test für Frequenz und Ausdauer von Auf- und Abbewegungen",
        'Landing': "Landungstest",
        'Balance': "Gleichgewichtstest",
        'AthleticShoulder': "Schultergelenk-Test",
        'Free': "Freier Test",
        'DJ': "Sprung aus der Tiefe",
        'Inside': "Innen",
        'Outside': "Außen",
        '踝关节': "Sprunggelenk",
        '肘关节': "Ellenbogengelenk",
        '髋关节': "Hüftgelenk",
        '颈部': "Nacken",
        '肩关节': "Schultergelenk",
        '躯干': "Rumpf",
        '膝关节': "Kniegelenk",
        '腕关节': "Handgelenk",
        '腕关节尺偏': "Handgelenk-Ulnardeviation",
        '髋关节外旋': "Hüftgelenk-Außenrotation",
        '髋关节内收': "Hüftgelenk-Adduktion",
        '髋关节外展': "Hüftgelenk-Abduktion",
        '颈部屈曲': "Nacken-Flexion",
        '颈部伸展': "Nacken-Extension",
        '颈部侧屈': "Nacken-Lateralflexion",
        '颈部旋转': "Nacken-Rotation",
        '肩关节内旋': "Schultergelenk-Innenrotation",
        '肩关节外旋': "Schultergelenk-Außenrotation",
        '肩关节屈曲': "Schultergelenk-Flexion",
        '踝内翻': "Sprunggelenk-Inversion",
        '踝外翻': "Sprunggelenk-Eversion",
        '足背屈': "Fuß-Dorsalextension",
        '足跖屈': "Fuß-Plantarflexion",
        '肘伸展': "Ellenbogen-Extension",
        '肘屈曲': "Ellenbogen-Flexion",
        '髋关节伸展': "Hüftgelenk-Extension",
        '髋关节屈曲': "Hüftgelenk-Flexion",
        '髋关节内旋': "Hüftgelenk-Innenrotation",
        '肩关节外展': "Schultergelenk-Abduktion",
        '躯干伸展': "Rumpf-Extension",
        '躯干侧屈': "Rumpf-Lateralflexion",
        '膝关节屈曲': "Kniegelenk-Flexion",
        '膝关节伸展': "Kniegelenk-Extension",
        '腕关节桡偏': "Handgelenk-Radialdeviation",
        '肩关节水平内收': "Schultergelenk-Horizontale Adduktion",
        '肩关节水平外展': "Schultergelenk-Horizontale Abduktion",
        '肩关节伸展': "Schultergelenk-Extension",
        '躯干屈曲': "Rumpf-Flexion",
        '躯干旋转': "Rumpf-Rotation",
        '腕关节旋前': "Handgelenk-Pronation",
        '肩关节内收': "Schultergelenk-Adduktion",
        '腕关节旋后': "Handgelenk-Supination",
        '腕关节屈曲': "Handgelenk-Flexion",
        '腕关节伸展': "Handgelenk-Extension",
        '仰卧位': "Rückenlage",
        '仰卧位（直腿）': "Rückenlage (gestreckte Beine)",
        '仰卧位（肘屈曲 90°）': "Rückenlage (90° Ellenbogenbeugung)",
        '仰卧位（肩外展 90° - 肘屈曲 90°）': "Rückenlage (90° Schulterabduktion - 90° Ellenbogenbeugung)",
        '侧卧位': "Seitenlage",
        '俯卧位': "Bauchlage",
        '俯卧位（肩外展 90° - 肘屈曲 90°）': "Bauchlage (90° Schulterabduktion - 90° Ellenbogenbeugung)",
        '半跪姿': "Halb-Kniestellung",
        '坐位': "Sitzposition",
        '坐位（肘屈曲 90°）': "Sitzposition (90° Ellenbogenbeugung)",
        '坐位（肩外展 90° - 肘屈曲 90°）': "Sitzposition (90° Schulterabduktion - 90° Ellenbogenbeugung)",
        '站立位': "Stehposition",
        '站立位（肘屈曲 90°）': "Stehposition (90° Ellenbogenbeugung)",
        '站立位（肩外展 90° - 肘屈曲 90°）': "Stehposition (90° Schulterabduktion - 90° Ellenbogenbeugung)",
        '肘屈曲90°': "90° Ellenbogenbeugung",
        '长坐位（无跖屈）': "Langes Sitzposition (keine Plantarflexion)",
        '长坐位（跖屈）': "Langes Sitzposition (Plantarflexion)"
    },
    StandardData: {
        Title: "Standardwertverwaltung (tragbarer Muskelkraft)",
        Assembly: "Bewegungskombination",
        Limbs: "Rumpf",
        Actions: "Bewegung",
        Pose: "Pose",
        Gender: "Geschlecht",
        Age: "Alter",
        PeakForce: "Spitzenkraft N/kg",
        Modify: "Standardwerte festlegen",
        FileBrowsing: "Dateibrowser",
        FileRequired: "Bitte Datei zum Import auswählen",
        DropFileHere: "Datei hier ablegen",
        clickToUpload: "Klicken zum Hochladen",
        SportTitle: "Standardwertverwaltung (sportliche Leistungsfähigkeit)",
        Mean: "Mittelwert",
        Outstanding: "Ausgezeichnete Werte",
        '青少年': "Jugendliche",
        '18~30': "18~30",
        '31~45': "31~45",
        '46~60': "46~60",
        'AgeGroup': "Altersgruppe",
        ModifySuccess: "Änderung erfolgreich",
        ErrorRaw: "Fehlerzeile",
        ErrorInfo: "Fehlerinformation",
        ErrorCount: "Fehleranzahl",
        Sure: "Bestätigen",
        ErrorStatistics: "Fehlernachweis",
        EmptyId: "Id darf nicht leer sein",
        IdParseError: "Id ungültig",
        EmptyValue: "Standardwert darf nicht leer sein",
        InvalidId: "Id ungültig",
        ValueParseError: "Standardwert ungültig"
    },
    Project: {
        Public: "Öffentlich",
        Private: "Privat",
        Title: "Testprojekt",
        FilterName: "Nach Projektnamen suchen",
        FilterSubject: "Nach Probandnamen suchen",
        Columns: {
            CreateTime: "Erstellungsdatum",
            ProjectName: "Projektname",
            CreatorName: "Erstellername",
            Operate: "Operation",
            Name: "Name",
            Gender: "Geschlecht",
            Age: "Alter",
            SubjectName: "Probandenname",
            Model: "Testbewegung"
        },
        RecordView: "Datensatz",
        Batch: "Massenverarbeitung",
        BatchDelete: "Massenlöschung",
        DeleteEmptyNotice: "Bitte auswählen, was gelöscht werden soll",
        Finish: "Fertig",
        Create: "Testprojekt erstellen",
        View: "Testprojekt",
        ProjectName: "Projektname",
        Subjects: "Probanden",
        AddSubject: "Proband hinzufügen",
        PublicProject: "Öffentliches Projekt",
        PrivateProject: "Privates Projekt",
        ProjectType: "Projekttyp",
        CreateTime: "Erstellungsdatum",
        CreateProject: "Projekt erstellen",
        Save: "Änderungen speichern",
        ProjectSubjectList: "Probanden im Projekt",
        NameFilter: "Nach Namen suchen",
        CreateSuccess: "Erstellung erfolgreich",
        ModifySuccess: "Änderung erfolgreich",
        DeleteSuccess: "Löschung erfolgreich",
        DeleteFailed: "Löschung fehlgeschlagen",
        NameTooLong: "Name zu lang, bitte nicht mehr als 24 Zeichen",
        RequireName: "Bitte Projektname eingeben",
        SubjectManagerment: "Probandenverwaltung",
        Added: "Bereits hinzugefügt",
        DeleteConfirm: "Das Löschen des Projekts löscht auch die zugehörigen Testdatensätze. Möchten Sie fortfahren?",
        ConfirmToDeleteRow: "Möchten Sie diesen Datensatz löschen?",
        ConfromToDeleteSubjetc: "Das Entfernen des Probanden löscht auch die zugehörigen Testdatensätze. Möchten Sie fortfahren?",
        DoNotAskAgain: "Nicht mehr fragen"
    },
    TrainingPlan: {
        Title: "Trainingsplan",
        PlanType: "Typ",
        Public: "Öffentlich",
        Private: "Privat",
        PlanName: "Planname",
        Columns: {
            CreateTime: "Erstellungsdatum",
            PlanName: "Planname",
            CreatorName: "Erstellername",
            Operate: "Operation",
            ActionCount: "Bewegungsanzahl",
            Seq: "Nummer",
            Action: "Bewegung",
            ActionTimes: "Wiederholungen",
            SubjectName: "Probandenname",
            Completeness: "Vollständigkeit",
            UsedTimes: "Testanzahl",
            Model: "Testbewegung",
            Gender: "Geschlecht"
        },
        Skipped: "Übersprungen",
        RecordView: "Datensatz",
        Batch: "Massenverarbeitung",
        BatchDelete: "Massenlöschung",
        Finish: "Fertig",
        Create: "Trainingsplan erstellen",
        Modify: "Ändern",
        Actions: "Bewegung",
        Subjects: "Probanden",
        Records: "Testdatensätze",
        Statue: "Status",
        Finished: "Abgeschlossen",
        Unfinish: "Unabgeschlossen",
        FilterName: "Nach Planname suchen",
        RequireName: "Bitte Planname eingeben",
        NameTooLong: "Name zu lang, bitte nicht mehr als 50 Zeichen",
        deleteRecord: "Datensatz löschen",
        DeleteConfirm: "Die Aktion löscht auch die zugehörigen Testdatensätze. Möchten Sie fortfahren?",
        AddAction: "Bewegung hinzufügen",
        TestActions: "Testbewegungen",
        CreatePlan: "Trainingsplan erstellen",
        SavePlan: "Trainingsplan speichern",
        Action: "Bewegung",
        Times: "Anzahl",
        ActionAssembly: "Bewegungskombination",
        RequireAssembly: "Bitte Bewegung auswählen",
        ConfirmDeleteAction: "Möchten Sie diese Bewegung löschen?"
    },
    DefaultGroup: "Standardgruppe",
    Empty_PhoneNumber: "Bitte Telefonnummer eingeben",
    Duplicate_PhoneNumber: "Telefonnummer bereits vorhanden, erneute Bindung nicht möglich",
    Invalid_BOMType: "Modultyp existiert nicht!",
    InsertFailed_Assembly: "Bewegung hinzufügen fehlgeschlagen!",
    Invalid_BOM: "Modul existiert nicht!",
    InsertFailed_BOM: "Modul hinzufügen fehlgeschlagen!",
    UpdateFailed_BOM: "Modul aktualisieren fehlgeschlagen!",
    DeleteFailed_BOM: "Modul löschen fehlgeschlagen!",
    Invalid_Project: "Projekt existiert nicht!",
    Invalid_Subject: "Proband existiert nicht!",
    Exsist_Account: "Konto bereits vorhanden!",
    Invalid_Account: "Konto existiert nicht!",
    Incorrect_OldPassword: "Altes Passwort falsch!",
    Invalid_Company: "Unternehmen nicht gefunden!",
    Invalid_CompanyID: "Ungültiger Firmencode!",
    Incorrect_ApplicationCode: "Ungültiger App-Code!",
    Incorrect_AccountOrPassword: "Benutzername oder Passwort falsch!",
    Expired_Captcha: "Captcha abgelaufen!",
    Incorrect_Captcha: "Captcha falsch!",
    Failed_SendCaptcha: "Captcha senden fehlgeschlagen!",
    Invalid_Captcha: "Ungültiges Captcha!",
    Empty_SubjectName: "Bitte Probandenname eingeben!",
    Repeat_SubjectName: "Proband mit gleichem Namen bereits vorhanden!",
    Duplicate_Requests: "Zu häufige Anfragen, bitte später erneut versuchen",
    UnknownError_Account: "Aktueller Benutzer existiert nicht!",
    Locked_Company: "Organisation/Firma gesperrt!",
    Expired_Authorization: "Organisations-/Firmen-App-Autorisierung abgelaufen!",
    Invalid_Authorization: "Organisations-/Firmen-App-Autorisierung nicht aktiviert!",
    Invalid_Parameter: "Ungültiger Parameter!",
    Invalid_License: "Lizenz ungültig!",
    Binded_License: "Lizenz bereits auf anderem Gerät gebunden!",
    Unbind_License: "Lizenz noch nicht gebunden!",
    Expired_License: "Lizenz abgelaufen!",
    Failed_License: "Lizenzprüfung fehlgeschlagen!",
    Empty_ApplictionCode: "Anwendungsnummer fehlt!",
    Invalid_ApplictionCode: "Anwendungsnummer ungültig!",
    Invalid_ApplictionEndPoint: "Ungültiger Systemknoten",
    Older_Version: "Ältere Versionsnummer",
    Empty_Version: "Keine gültige Versionsnummer",
    Duplicate_ApplicationCode: "Doppelter Systembezeichner",
    Invalid_Application: "Ungültiges Testsystem",
    Empty_Upgrade: "Wählen Sie die zu aktualisierende Datei aus",
    Invalid_Version: "Ungültige Versionsnummer",
    Invalid_Record: "Ungültiger Datensatz",
    NotFound_Record: "Datensatz nicht gefunden",
    Failed_ResetPassword: "Passwort zurücksetzen fehlgeschlagen",
    Incomplete_Infomation: "Unvollständige Eingabeinformationen",
    Invalid_Binded: "Ungültige Bindungsaufzeichnung",
    ParallelLimit_License: "Überschreitung der maximalen Bindungsanzahl",
    Exsist_PermissionGroup: "Berechtigungsgruppe bereits vorhanden",
    Invalid_PermissionDenied: "Berechtigung unzureichend",
    Invalid_PermissionGroup: "Ungültige Rollenberechtigung",
    Duplicate_Project: "Dupliziertes Testprojekt",
    Duplicate_SportProject: "Sportprojektname darf nicht dupliziert werden",
    Invalid_SportProject: "Ungültiges Sportprojekt",
    Invalid_File: "Datei existiert nicht!",
    UploadFailed_NoFile: "Keine Datei zum Hochladen vorhanden!",
    DownloadFailed_NoFile: "Datei nicht gefunden!",
    Incorrect_Format: "Datenformat ungültig",
    UploadFailed_Timeout: "Upload-Zeitüberschreitung!",
    DownloadFailed_Timeout: "Download-Zeitüberschreitung!",
    Repeat_Name: "Benutzer mit gleichem Namen bereits vorhanden",
    Empty_Account: "Bitte Konto eingeben",
    Empty_Password: "Bitte Passwort eingeben",
    Empty_Name: "Bitte Name eingeben",
    Invationing_SubjectEmail: "Diese E-Mail wird gerade eingeladen",
    Invationing_SubjectName: "Athletenname wird gerade eingeladen",
    Invalid_InvationLink: "Link ungültig",
    Submit_SubjectInfo: "Athlet hat Informationen eingereicht",
    Incorrect_Subject: "Athlet existiert nicht",
    Incomplete_InvationCode: "Einladungscode fehlt",
    Duplicate_Subject: "Athletenname bereits vorhanden",
    Duplicate_InvationEmail: "Innerhalb von fünf Minuten kann nicht dieselbe E-Mail eingeladen werden",
    Invalid_RecordSide: "Ungültige Reihenfolge",
    NotBe_SameDay: "Ausgewählte Daten müssen am selben Tag sein",
    Invalid_Indicator: "Ungültiger Indikator",
    Invalid_UserName: "Benutzername darf nicht leer sein",
    UnUpload_SubjectOrProject: "Testelemente oder Athleten nicht hochgeladen",
    UnUpload_Subject: "Athleten nicht hochgeladen",
    Duplicate_SubjectName: "Probandenname dupliziert",
    SyncData: "Bitte zuerst Daten abrufen",
    Duplicate_TrainingPlanName: "Duplizierter Trainingsplanname",
    Invalid_TrainingPlan: "Ungültiger Trainingsplan",
    Invalid_Key: "Ungültiger Schlüsselwert",
    Failed_CallService: "Serviceaufruf fehlgeschlagen",
    FileNotExist: "Datei existiert nicht",
    Repeat_ProjectName: "Projektname dupliziert"
}